<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content class="py-16">
      <v-row dense>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium py-0">
            {{ $t('transfer_summary') }}
          </h1>
        </v-col>
      </v-row>
      <v-row
        v-if="
          clientRequest && !isObjectEmpty(clientRequest.permanentInstruction)
        "
        dense
      >
        <v-col cols="12">
          <v-list dense>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1 text-body-1"
                    >
                      {{ $t('transfer_request_operation') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1 text-body-1"
                    >
                      {{
                        operation == 'W'
                          ? $t('transfer_request_operation_withdrawal')
                          : $t('transfer_request_operation_deposit')
                      }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver"></v-divider>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_name') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ clientRequest.permanentInstruction.beneficiary }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item
              class="pl-0"
              v-if="
                clientRequest.permanentInstruction.accountType !== 'avsInternal'
              "
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_beneficiary_data') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      <span v-if="clientRequest.permanentInstruction.bnfEmail">{{ clientRequest.permanentInstruction.bnfEmail}}</span>
                      <span v-if="clientRequest.permanentInstruction.bnfPhone">{{ clientRequest.permanentInstruction.bnfPhone}} </span>
                      <span v-if="clientRequest.permanentInstruction.bnfAddres1">{{ clientRequest.permanentInstruction.bnfAddres1 }} {{ clientRequest.permanentInstruction.bnfAddres2 }} - </span>
                      <span v-if="clientRequest.permanentInstruction.bnfCountry">{{ clientRequest.permanentInstruction.bnfCountry }} {{ clientRequest.permanentInstruction.bnfState }} {{ clientRequest.permanentInstruction.bnfCity }}, {{ clientRequest.permanentInstruction.bnfZipcode }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="
                clientRequest.permanentInstruction.accountType !== 'avsInternal'
              "
              class="silver"
            />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_account_type') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ $t(handleAccountType(clientRequest.permanentInstruction.accountType)) }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_financial_institution_of_beneficiary') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon class="mr-sm-5 d-none d-sm-flex" v-text="'mdi-chevron-right'" color="primary"/>
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ clientRequest.permanentInstruction.bnfBankName }} - {{ clientRequest.permanentInstruction.bnfBankAccNumber }}
                      <span v-if="clientRequest.permanentInstruction.accountType !== 'nfiAccount'">
                        <span v-if="clientRequest.permanentInstruction.bnfBankABA">ABA/SWIFT {{ clientRequest.permanentInstruction.bnfBankABA }} </span>
                        <span v-if="clientRequest.permanentInstruction.bnfBankAddres1">- {{ clientRequest.permanentInstruction.bnfBankAddres1 }} {{ clientRequest.permanentInstruction.bnfBankAddres2 }}</span>
                        <span v-if="clientRequest.permanentInstruction.bnfBankCountry"> {{ clientRequest.permanentInstruction.bnfBankCountry }} {{ clientRequest.permanentInstruction.bnfBankState }} {{ clientRequest.permanentInstruction.bnfBankCity }}</span>
                      </span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item v-if="clientRequest.permanentInstruction.nfiName">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_receiving_bank') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ clientRequest.permanentInstruction.nfiName }} - {{ clientRequest.permanentInstruction.nfiAccountNumber }}
                      <span v-if="clientRequest.permanentInstruction.bnfBankABA">- ABA/SWIFT {{ clientRequest.permanentInstruction.bnfBankABA }} -</span> {{ clientRequest.permanentInstruction.bnfBankCity }} {{ clientRequest.permanentInstruction.bnfBankCountry }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="clientRequest.permanentInstruction.nfiName"
              class="silver"
            />
            <v-list-item
              v-if="clientRequest.permanentInstruction.intermBankIsUsed"
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_intermediary') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ clientRequest.permanentInstruction.intermBankName }} - {{ clientRequest.permanentInstruction.intermBankAccNumber }}
                      <span v-if="clientRequest.permanentInstruction.intermBankABA">ABA/SWIFT {{ clientRequest.permanentInstruction.intermBankABA }} </span>
                      <span v-if="clientRequest.permanentInstruction.intermBankAddres1">- {{ clientRequest.permanentInstruction.intermBankAddres1 }} {{ clientRequest.permanentInstruction.intermBankAddres2 }}</span>
                      <span v-if="clientRequest.permanentInstruction.intermBankCountry"> {{ clientRequest.permanentInstruction.intermBankCountry }} {{ clientRequest.permanentInstruction.intermBankState }} {{ clientRequest.permanentInstruction.intermBankCity }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="clientRequest.permanentInstruction.intermBankIsUsed"
              class="silver"
            />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_request_amount') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ clientRequest.amount | currency }} {{ clientRequest.currency.currencyCode }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver"></v-divider>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_request_start_date') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      {{ clientRequest.schedule.start }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item v-if="clientRequest.schedule.recurrent" class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title class="item-text primary--text text-body-1">
                      {{ $t('transfer_request_recurrence') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle class="ml-sm-5 item-text primary--text text-body-1">
                      <span>{{ $t('transfer_request_monthly_frequency') }}: {{ clientRequest.schedule.monthlyFrequency }}</span>  -
                      <span>{{ $t('transfer_request_business_day') }}: {{ clientRequest.schedule.day }}</span>  -
                      <span>{{ $t('transfer_request_end_day') }}: {{ clientRequest.schedule.end }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="clientRequest.schedule.recurrent"
              class="silver"
            ></v-divider>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_observations') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ clientRequest.permanentInstruction.bnfReference }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver"></v-divider>
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_instructions') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ clientRequest.permanentInstruction.avsInternalRemark }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
          </v-list>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import { isObjectEmpty } from '@/utils'

export default {
  components: {
    WizardForm
  },
  props: {
    clientRequest: {
      type: [Object],
      required: true
    },
    operation: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      accountTypes: [
        { value: 'localCheckingAccount', t: 'transfer_account_type_1' },
        { value: 'localSavingsAccount', t: 'transfer_account_type_2' },
        { value: 'nfiAccount', t: 'transfer_account_type_3' },
        { value: 'intlBankAccount', t: 'transfer_account_type_4' },
        { value: 'avsInternal', t: 'transfer_internal_account' }
      ]
    }
  },
  methods: {
    isObjectEmpty(objectName) {
      return isObjectEmpty(objectName)
    },
    handleAccountType(accountType) {
      const type = this.accountTypes.find(item => item.value == accountType)
      return type?.t
    }
  }
}
</script>
<style lang="sass" scoped>
.item-text
  font-size: 1.143rem
</style>
